import React, { useEffect, useState } from 'react';
import { BsFillEyeFill, BsFillEyeSlashFill } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getLocalStorage, patchWithToken } from '../API/Api';
import { validatePwd } from '../assets/Helper/utils';
import SAVE_ICON from '../assets/icons/ComniqaiIcon-V3.0/save-icon.svg';
import { navigateToLogin } from '../utils/navigateToLogin';

const ValidationErrors = {
  empty: {
    old_password: 'Old Password Required',
    password: 'New Password Required',
    confirm_password: 'Confirm new Password Required',
  },
  invalid: {
    password: 'Password must be of 8 to 10 characters; including 1 uppercase & 1 lowercase letter, 1 numeric character & 1 special character (@#$/_-!&*).',
  },
};

const ChangePassword = () => {
  const Navigate = useNavigate();
  const [apiTokenData, setApiTokenData] = useState('');
  const [showPwd, setShowPwd] = useState({
    old_password: false,
    password: false,
    confirm_password: false,
  });
  const [values, setValues] = useState({
    old_password: '',
    password: '',
    confirm_password: '',
  });
  const [errors, setErrors] = useState({
    confirm_password: '',
    old_password: '',
    password: '',
  });
  const { old_password, password, confirm_password } = values;

  const toggleShowPassword = (field) => {
    setShowPwd((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  useEffect(() => {
    let token = getLocalStorage('apiToken');
    if (token) {
      setApiTokenData(JSON.parse(token));
    }
  }, []);

  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const handleClick = () => {
    const tempErrors = { ...errors };
    Object.keys(values).forEach((key) => {
      if (!values[key]) {
        tempErrors[key] = ValidationErrors.empty[key];
      } else {
        if (key === 'password' && !validatePwd(values[key])) {
          tempErrors.password = ValidationErrors.invalid.password;
        }
      }
    });
    setErrors(tempErrors);

    if (Object.values(tempErrors).filter((obj) => !!obj).length > 0) {
      return false;
    }
    patchWithToken('change_password/', apiTokenData, values)
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.message);
          navigateToLogin();
        } else {
          toast.error(response.message);
        }
      })
      .catch((error) => {
        toast.error('Something went wrong');
      });
  };

  return (
    <>
      <div className='setting-card-section'>
        <div className='setting-card-text'>
          <h5 className='outfit-semibold mb-0'>Change Password</h5>
          <p className='outfit-regular'>Update your account password regularly to keep your account secure.</p>
        </div>
        <form>
          <div className='row chatbox-field mt-4'>
            <div className='col-12 col-md-7'>
              <div className='chatbox-input-text input-GPT new'>
                <label className='outfit-medium'>Old Password*</label>
                <div className='chatbox-input-field user-profile-password position-relative'>
                  <input
                    type={showPwd.old_password ? 'text' : 'password'}
                    placeholder='**********'
                    className='form-control chatbox-input box-shadow-hover'
                    name='old_password'
                    value={old_password}
                    autoComplete='off'
                    onChange={handleChange}
                  />
                  <button type='button' onClick={() => toggleShowPassword('old_password')} className='password-toggle-btn'>
                    {showPwd.old_password ? <BsFillEyeFill /> : <BsFillEyeSlashFill />}
                  </button>
                  <div className='chat-error'>{errors.old_password && <span className='text-danger insta-smart-error'>{errors.old_password}</span>}</div>
                </div>
              </div>
              <div className='chatbox-input-text input-GPT new mt-4'>
                <label className='outfit-medium'>New Password*</label>
                <div className='chatbox-input-field user-profile-password position-relative'>
                  <input
                    type={showPwd.password ? 'text' : 'password'}
                    placeholder='**********'
                    className='form-control chatbox-input box-shadow-hover'
                    name='password'
                    value={password}
                    autoComplete='off'
                    onChange={handleChange}
                  />
                  <button type='button' onClick={() => toggleShowPassword('password')} className='password-toggle-btn'>
                    {showPwd.password ? <BsFillEyeFill /> : <BsFillEyeSlashFill />}
                  </button>
                  <div className='chat-error'>{errors.password && <span className='text-danger insta-smart-error'>{errors.password}</span>}</div>
                </div>
              </div>
              <div className='chatbox-input-text input-GPT new mt-4'>
                <label className='outfit-medium'>Confirm Password*</label>
                <div className='chatbox-input-field user-profile-password position-relative'>
                  <input
                    type={showPwd.confirm_password ? 'text' : 'password'}
                    placeholder='**********'
                    className='form-control chatbox-input box-shadow-hover'
                    name='confirm_password'
                    value={confirm_password}
                    autoComplete='off'
                    onChange={handleChange}
                  />
                  <button type='button' onClick={() => toggleShowPassword('confirm_password')} className='password-toggle-btn'>
                    {showPwd.confirm_password ? <BsFillEyeFill /> : <BsFillEyeSlashFill />}
                  </button>
                  <div className='chat-error'>{errors.confirm_password && <span className='text-danger insta-smart-error'>{errors.confirm_password}</span>}</div>
                </div>
              </div>
            </div>
          </div>
          <div className='d-flex align-items-center justify-content-start mt-3'>
            <button type='button' className='chatbot-save-btn outfit-medium d-flex align-items-center gap-2' onClick={handleClick}>
              <img src={SAVE_ICON} alt='save-icon' />
              Save
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default ChangePassword;
